import React from 'react';
import {
  MDBCol as Col,
  MDBContainer as Container,
  MDBRow as Row,
  MDBFooter as Footer,
} from 'mdbreact';

const FooterSection = () => {
  return (
    <Footer color='elegant-color' className='font-small pt-0 mt-5'>
      <Container>
        <Row className='pt-5 mb-3'>
          <Col md='6' className='mb-5 mx-auto text-center'>
            <img src='MQM LOGO.png' height='30' alt='' />
          </Col>
        </Row>
        <hr className='rgba-white-light w-75' />
        <Row className='d-flex text-center justify-content-center mb-md-0 mb-4'>
          <Col md='8' sm='12' className='mt-3'>
            <p style={{ lineHeight: '1.7rem' }}>
              Mega Q Mart (formerly known as Nepa Q Mart) is an established wet
              and dry market along the busy highway of EDSA, Cubao that provides
              quality fresh goods at affordable prices.
            </p>
          </Col>
        </Row>
        <hr className='clearfix d-md-none rgba-white-light w-75' />
        <Row className='pb-3'>
          <Col md='12'>
            <div className='mb-5 flex-center'>
              <a href='#!' className='fb-ic'>
                <i className='fab fa-facebook-f fa-lg white-text mr-4'> </i>
              </a>
              <a href='#!' className='tw-ic'>
                <i className='fab fa-twitter fa-lg white-text mr-4'> </i>
              </a>
              <a href='#!' className='ins-ic'>
                <i className='fab fa-instagram fa-lg white-text mr-4'> </i>
              </a>
            </div>
          </Col>
        </Row>
      </Container>
      <div className='footer-copyright text-center py-3'>
        <Container fluid>
          &copy; {new Date().getFullYear()} Copyright:
          <a href='#!'> Mega Q Mart </a>
          by
          <a href='https://kennethrodriguez.com'>
            <img
              src='/kenrod-white.png'
              alt='kenneth rodriguez'
              height='25px'
              className='ml-1 mb-1'
            />
          </a>
        </Container>
      </div>
    </Footer>
  );
};

export default FooterSection;
